<template>
  <div class="download-wrap">
    <!-- 公用头部 -->
    <headers :activeindex="7"></headers>
    <div class="download-banner-wrap">
      <div class="download-banner">
        <div class="title">SDK下载中心</div>
        <div class="subtitle">安全可靠，技术成熟</div>
        <img src="../../assets/image/download/download-right-bg.jpg" alt="背景" class="banner-bg-img">
      </div>
    </div>
    <!-- 主体内容 -->
    <div class="download-main">
      <div class="main" v-for="(item, index) in downloadList" :key="index">
        <div class="title">{{ item.title }}</div>
        <div class="sdk-wrap" v-for="(sdkItem, sdkIndex) in item.sdkList" :key="sdkIndex">
          <div class="top-wrap">
            <img src="../../assets/image/download/ad-icon.jpg" alt="icon" class="info-icon">
            <div class="info-wrap">
              <div class="name">{{ sdkItem.name }}</div>
              <div>
                <span>开发者：上海倍孜网络技术有限公司</span> |
                <span>版本号：{{ sdkItem.version }}</span> |
                <span>更新时间：{{ sdkItem.updateTime }}</span>
              </div>
            </div>
            <div class="btn-wrap">
              <el-button type="primary" class="download-btn" @click="handleClick(sdkItem.downloadUrl)">下载SDK</el-button>
            </div>
          </div>
          <div class="bottom-wrap">
            <div class="bottom-left-wrap">
              <div class="info-title">更新内容：</div>
              <div class="cont" v-for="(cont, updateIndex) in sdkItem.contentList" :key="updateIndex + Math.random() * 1000">
                {{ updateIndex + 1 }} {{ cont }}
              </div>
            </div>
            <div class="bottom-right-wrap">
              <div>
                <div class="info-title">功能介绍：</div>
                <div class="info-wrap">
                  <div class="cont" v-for="(info, infoIndex) in sdkItem.infoList" :key="infoIndex + Math.random() * 1000">
                    {{ info }}
                  </div>
                </div>
              </div>
              <div class="link-wrap">
                <div class="link" v-for="(help, helpIndex) in sdkItem.helpList" :key="helpIndex + Math.random() * 1000">
                  <a target="_blank" :href="help.url">{{ help.name }}</a>
                  <span class="divider" v-if="helpIndex + 1 !== sdkItem.helpList.length">|</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 备案信息 -->
    <div class="buttom-wrap">
      <span class="tips" :style="{ 'width': '100%', 'text-align': 'center' }">All Rights Reserved. <span class="tips-number" @click="handleOpenNewPage">{{ IcpNumber }}</span></span>
      <!-- <span class="tips">
        All Rights Reserved. 沪ICP备 17036269号.
        <span class="tips-number" @click="handleOpenNewPage"><span class="bgSpan"></span>沪公网安备 31010402006552号</span></span> -->
    </div>
  </div>
</template>

<script>
  import headers from "@/component/header";

  export default {
    name: 'download-new',
    components: { headers },
    data() {
      return {
        downloadList: [
          {
            title: 'Android SDK 下载',
            sdkList: [
              {
                name: 'AdScope SDK-Android',
                version: '5.2.1.3',
                updateTime: '2025/04/29 14:00:00',
                contentList: [ '已知问题修复', '包体优化', '新增激励视频' ],
                downloadUrl: 'https://resource.ad-scope.com.cn/sdk/AdScope-SDK-Android_5.2.1.3.zip',
                infoList: [
                  '为开发者提供调整广告变现策略及数据分析的服务',
                ],
                helpList: [
                  { name: 'AdScope SDK 个人信息保护规则', url: 'https://sdkdocv3.beizi.biz/#/zh-cn/guide/UsePrivacy' },
                  { name: '开发者个人信息保护合规指引', url: 'https://sdkdocv3.beizi.biz/#/zh-cn/guide/ComplianceGuidelines' },
                ],
              },
            ]
          },
          {
            title: 'iOS SDK 下载',
            sdkList: [
              {
                name: 'AdScope SDK-iOS',
                version: '5.2.0.2',
                updateTime: '2025/04/08 14:00:00',
                contentList: [ '政策合规升级', '性能优化', '已知崩溃修复' ],
                downloadUrl: 'https://resource.ad-scope.com.cn/sdk/AMPS_ADN_5.2.0.2_3762593abaaef13981ab7ff42a4a605c.zip',
                infoList: [
                  '为开发者提供调整广告变现策略及数据分析的服务',
                ],
                helpList: [
                  { name: 'AdScope SDK 个人信息保护规则', url: 'https://sdkdocv3.beizi.biz/#/zh-cn/guide/UsePrivacy' },
                  { name: '开发者个人信息保护合规指引', url: 'https://sdkdocv3.beizi.biz/#/zh-cn/guide/ComplianceGuidelines' },
                ],
              },
            ]
          },
        ]
      }
    },
    computed: {
      IcpNumber() {
        if (location.host.includes('ad-scope.com.cn')) return '沪ICP备20011467号-7';
        if (location.host.includes('adscope.com.cn')) return '沪ICP备20011467号-6';
        if (location.host.includes('adscope.cn')) return '沪ICP备20011467号-4';
        if (location.host.includes('adscope.xyz')) return '沪ICP备20011467号-5';
        if (location.host.includes('beizi.biz')) return '沪ICP备20011467号-1';
        if (location.host.includes('beizi.info')) return '沪ICP备20011467号-3';
        if (location.host.includes('beizi.online')) return '沪ICP备20011467号-2';
        return '沪ICP备20011467号';
      }
    },
    methods: {
      handleClick(url) { window.location.href = url; },
      // 点击备案号打开新页面
      handleOpenNewPage() {
        window.open('https://beian.miit.gov.cn/', "recordNumber");
      }
    }
  }
</script>

<style lang="scss" scoped>
  .download-wrap{
    background: #ebebeb;
  }
  .download-banner-wrap{
    width: 100%;
    height: 500px;
    margin-bottom: 50px;
    background: #fff;
    background: url("../../assets/image/download/download-bg.jpg") center center no-repeat;
    background-size: 100% 100%;
    .download-banner{
      width: 1200px;
      margin: 0 auto;
      position: relative;
      .title{
        padding: 200px 0 30px;
        font-weight: bolder;
        font-size: 54px;
        letter-spacing: 10px;
      }
      .subtitle{
        font-size: 26px;
        letter-spacing: 10px;
      }
      .banner-bg-img{
        position: absolute;
        right: 80px;
        top: 120px;
      }
    }
  }
  /* 主体内容 */
  .download-main {
    .main {
      box-sizing: border-box;
      width: 1200px;
      margin: 0 auto 30px;
      padding: 20px 20px 0 20px;
      border-radius: 10px;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
      background: #ffffff;
      &:last-child {
        margin-bottom: 50px;
      }
      .title{
        font-size: 16px;
        font-weight: bolder;
        padding-bottom: 20px;
      }
      .sdk-wrap {
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px dashed #595959;
        &:last-child {
          margin: 0;
          border: none;
        }
        /* 顶部 */
        .top-wrap {
          display: flex;
          align-items: center;
          height: 60px;
          .info-icon {
            margin-right: 20px;
          }
          .info-wrap {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            height: 60px;
            color: #595959;
          }
          .btn-wrap {
            .download-btn {
              width: 200px;
              height: 40px;
              line-height: 40px;
              padding: 0;
              border-radius: 20px;
            }
          }
        }
        /* 底部 */
        .bottom-wrap {
          display: flex;
          .bottom-left-wrap, .bottom-right-wrap {
            flex: 1;
            margin-top: 20px;
            padding: 20px;
            background: #fafafa;
            border-radius: 10px;
            font-size: 12px;
            .info-title{
              padding-bottom: 10px;
              font-weight: bolder;
              color: #575757;
            }
            .cont{
              padding-bottom: 10px;
              &:last-child {
                padding-bottom: 0;
              }
            }
          }
          /* 更新信息 */
          .bottom-left-wrap {
            margin-right: 10px;
          }
          /* 链接 */
          .bottom-right-wrap {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 10px;
            a {
              color: #007aff;
              &:hover {
                text-decoration: underline;
              }
            }
            .info-wrap {
              margin-bottom: 20px;
            }
            .link-wrap {
              display: flex;
              align-items: center;
              .divider {
                margin: 0 20px;
              }
            }
          }
        }
      }
    }
  }
  /* 备案信息 */
  .buttom-wrap {
    font-size: 14px;
    box-sizing: border-box;
    display: flex;
    height: 50px;
    line-height: 50px;
    color: #b8b8b8;
    background: #1c1f25;
    .tips {
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      .tips-number {
        cursor: pointer;
        padding-left: 8px;
      }
      .bgSpan{
        padding-left: 20px;
        background: url("../../assets/image/authentication.png") left no-repeat;
        background-size: 18px 20px;
        margin-right: 10px;
      }
    }
  }
</style>
